<template>
  <p>Nie masz praw dostępu.</p>
</template>

<script>
export default {
  name: "accessDenied",
};
</script>